import script from "./ResetConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./ResetConfirm.vue?vue&type=script&setup=true&lang=js"

import "./ResetConfirm.vue?vue&type=style&index=0&id=bf9c5238&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf9c5238"]])

export default __exports__